<template>
    <CategoriesFilter
        v-model="filteredCategories"
        :categoryIDs="categoryIDs"
    />
</template>
<script setup lang="ts">
import { CategoriesFilter } from '@/components';
import type { RacesGroupsCategoriesMap } from '@/utilities/RacesGroupsCategoriesMap';
import { computed } from 'vue';

const props = defineProps<{
    /**
     * Map of the races, groups and categories
     */
    racesGroupsCategoriesMap: RacesGroupsCategoriesMap;

    /**
     * The currently selected groups (presumably from a ToolbarRaceGroupsFilter)
     */
    groupID: number | number[];

    /**
     * The current raceID (if any)
     */
    raceID?: number | null;
}>();
const filteredCategories = defineModel<number[]>({ required: true });

const categoryIDs = computed(() => {
    return props.racesGroupsCategoriesMap.GetCategoryIDs(props.groupID, props.raceID);
});
</script>
